import React from "react";
import bannerImg from "../../assets/images/bloggs.webp";
import "../../styles/Webdevelopment.css";
import { Link } from "react-router-dom";

function seobanner() {
  return (
    <div>
      <section className="webbanner">
        <div className="webbanner-content">
          <h1>
            Best Social Media Marketing Services to Grow Your Business Fast in
            2026
          </h1>
          <p>
            In nowadays’s virtual international, having a strong on-line
            presence is now not optional it’s critical. Businesses that actively
            engage on social media systems are able to connect with their target
            audience, construct agree with, and force consistent increase.
            Choosing the proper <b>social media marketing services</b>  can help your brand reach the proper target market and generate
            actual commercial enterprise effects.
          </p>
          <div className="webbanner-cta">
            <a href="./Contact" className="webbanner-btn primary">
              Get Free Consultation →
            </a>
          </div>
        </div>
        <div className="webbanner-image">
          <img src={bannerImg} alt="Web Development Solutions" />
        </div>
      </section>
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <span>Social Media Marketing Service</span>
      </div>
    </div>
  );
}

export default seobanner;
